import React, { useState } from "react";
import { Layout, Row, Col, Typography } from "antd";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
import { BRAND_NAME } from "config/config";

const LayoutFooter = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Layout.Footer>
      <Row>
        <Col align="center" span={24}>
          <Typography.Text type="secondary">{BRAND_NAME}</Typography.Text>
        </Col>
        <Col align="center" span={24}>
          <Typography.Text type="secondary">© Powered by ViVN</Typography.Text>
        </Col>
      </Row>
    </Layout.Footer>
  );
};
export default LayoutFooter;
